import { render, staticRenderFns } from "./TestPayment.vue?vue&type=template&id=e874e02c&scoped=true&"
import script from "./TestPayment.vue?vue&type=script&lang=js&"
export * from "./TestPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e874e02c",
  null
  
)

export default component.exports